interface ProgressBarProps {
  current: number
  total: number
  label?: string
  tone?: 'default' | 'danger'
  className?: string
}

export function ProgressBar({
  current,
  total,
  label,
  tone = 'default',
  className = 'h-2',
}: ProgressBarProps) {
  const indeterminate = total <= 0
  const percent = indeterminate ? 100 : Math.min(100, (current / Math.max(total, 1)) * 100)
  const barColor = tone === 'danger' ? 'bg-red-500' : 'bg-blue-600'

  return (
    <div
      className={`w-full bg-gray-200 rounded-full overflow-hidden ${className}`}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={indeterminate ? undefined : total}
      aria-valuenow={indeterminate ? undefined : current}
    >
      <div
        className={`h-full ${barColor} rounded-full transition-all ${indeterminate ? 'animate-pulse' : ''}`}
        style={{ width: `${percent}%` }}
      />
    </div>
  )
}
